/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createIntegrationPrivacyRequest} from '../api'

export const useMutationCreateIntegrationPrivacyRequest = createReactQueryMutationHook('createIntegrationPrivacyRequest', createIntegrationPrivacyRequest)
